<span *ngIf="created" class="timestamp">
  Created:&nbsp;{{ created | date : timestampFormat }}
</span>
<span *ngIf="updated" class="timestamp">
  Updated:&nbsp;{{ updated | date : timestampFormat }}
</span>
